import GiftCardEditForm from '../../components/pages/gift_card_sessions/GiftCardEditForm.vue'

export default {
  components: {
    GiftCardEditForm
  }
}
